import { computed, type ComputedRef } from 'vue'
import { useTranslator } from '@/i18n'
import { type CountryCode, countryCodes } from '@/helpers/country-codes'
import type { SelectOption } from '@/components/ui/inputs/th-select.ts'

export function useCountries(): {
    countries: ComputedRef<SelectOption<CountryCode>[]>
} {
    const { getCountryName } = useTranslator()

    const countries = computed(() =>
        countryCodes.map((code): SelectOption<CountryCode> => {
            return {
                label: String(getCountryName(code)),
                value: code,
            }
        })
    )

    return {
        countries,
    }
}
